import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

interface RiderBenefitContainerStyledProps {
  $hideBorder?: boolean;
}

export const RiderBenefitContainerStyled = styled(
  Box
)<RiderBenefitContainerStyledProps>(({ $hideBorder }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderTop: $hideBorder ? 'none' : '1px solid #E6E6E6',
  padding: '24px 0px',
  margin: $hideBorder ? '0px' : '0px 40px',
}));

export const MobileRiderBenefitContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '0px 0px 24px 0px',
});

export const RiderLinesContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid #E6E6E6',
  borderRadius: '4px',
  width: '100%',
  padding: '12px 24px',
  '.rider-line:last-child': {
    borderBottom: 'none',
    paddingBottom: '0px',
  },
  '.rider-line:nth-child(n + 2)': {
    paddingTop: '8px',
  },
});

export const RiderItemStyled = styled(Box)({
  '@media (min-width: 744px)': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  width: '100%',
  paddingBottom: '8px',
  borderBottom: '1px solid #E6E6E6',
});

export const RiderCheckboxContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  'label, p': {
    fontSize: '16px !important',
    fontWeight: '400 !important',
    letterSpacing: '0.15px !important',
    textAlign: 'left',
    color: ' #000000',
  },
});

export const RiderPPPContainerStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'right',
  justifyContent: 'center',
});

export const RiderDrawerLabelContainer = styled(Box)({
  padding: '4px 6px',
  maxHeight: '32px',
});

export const RiderTotalCostContainerStyled = styled(Box)({
  backgroundColor: '#DEE7FF',
  borderRadius: '4px',
  padding: '12px 24px',
  marginTop: '12px',
  '@media (min-width: 744px)': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export const TotalCostTextStyled = styled(Typography)({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '24px',
  letterSpacing: '0.1px',
  textAlign: 'center',
  '@media (max-width: 743px)': {
    textAlign: 'right',
    paddingRight: '0px',
  },
  height: 'fit-content',
  paddingRight: '12px',
});

export const TotalCostCostStyled = styled(Typography)({
  fontSize: '33px',
  fontWeight: '400',
  lineHeight: '46.2px',
  letterSpacing: '0.0025em',
  textAlign: 'center',
  '@media (max-width: 743px)': {
    textAlign: 'right',
  },
});

export const RiderLabelOnlyStyled = styled(Box)({
  p: {
    marginBottom: '0px',
  },
  paddingLeft: '6px',
  paddingTop: '8px',
});
